<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="md" @click="modals.create_qualification_modal = true; newQualification.name = ''">Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="qualifications">
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Qualifications Options</th>
          <th class="text-center">Actions</th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </td>

          <td class="text-center">
            <base-dropdown class="dropdown"
                           position="center">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" @click="modals.update_modal = true; qualificationId = row.qualification_id; updateQualificationById.name = row.name">Update</a>
                <a class="dropdown-item" @click="modals.confirmation_modal = true; qualificationId = row.qualification_id">Delete</a>
              </template>
            </base-dropdown>
          </td>

        </template>

      </base-table>
    </div>

    <div class="row" id="div-create-industry-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.create_qualification_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">CREATE NAME: QUALIFICATION</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Name: </label> 
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Name"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="newQualification.name"
                                    />
                                  </div>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.create_qualification_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="createQualification()">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-update-qualification-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.update_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">UPDATE NAME: QUALIFICATION</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Name: </label> 
                                  <div class="col-sm-9">
                                    <base-input alternative=""
                                                placeholder="Name"
                                                input-classes="form-control-alternative"
                                                type="text"
                                                v-model="updateQualificationById.name"
                                    />
                                  </div>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.update_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="updateQualification(qualificationId)">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-confirmation-modal">
       <modal :show.sync="modals.confirmation_modal">
         <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Delete</h5>
         </template>
         <div>
          Are you sure?
         </div>
         <template slot="footer">
             <base-button type="secondary" @click="modals.confirmation_modal = false">Close</base-button>
             <base-button type="primary" @click="deleteQualification(qualificationId)">Yes</base-button>
         </template>
       </modal>

    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :perPage="10" :total="totalQualification" :value="pageNumber"></base-pagination>
    </div>

  </div>
</template>
<script>
  import EventBus from './../../event-bus';

  export default {
    name: 'qualifications-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        totalQualification: 0,
        show: false,
        message: '',
        qualificationId: 0,
        newQualification: {
          name: ''
        },
        updateQualificationById: {
          name: ''
        },
        modals: {
          create_qualification_modal: false,
          confirmation_modal: false,
          update_modal: false
        }
      }
    },
    computed: {
      qualifications()
      {
        return this.$store.getters.qualifications;
      },
      pageNumber()
      {
        return parseInt(this.$route.query.page);
      },
      totalQualifications()
      {
        return this.totalQualification;
      }
    },
    watch: {
      pageNumber() {
        this.getQualifications(this.$route.query.page);
      }
    },
    mounted() {
      this.getQualifications(1);
      this.getTotalQualifications();
    },
    methods: {
      getQualifications : function (page_number) {
        this.$store.dispatch('fetchQualifications', page_number).then (response => {
          this.$store.dispatch('updateState', {
              key : 'qualifications',
              value : response.data
          });
        });
      },

      getTotalQualifications()
      {
        this.$store.dispatch('fetchTotalQualification').then (response => {
          this.totalQualification = parseInt(response.data);
        });
      },

      createQualification()
      {
        this.$store.dispatch('createQualification', {
          name: this.newQualification.name
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.create_qualification_modal = false;
            this.getQualifications(this.$route.query.page);
            this.getTotalQualifications();
            EventBus.$emit('updateQualificationCount');
          }  else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        }).catch (error => {
          console.log(error.message);
        });
      },

      updateQualification : function (qualification_id)
      {
        this.$store.dispatch('updateQualification', {
          id: qualification_id,
          name: this.updateQualificationById.name
        }).then (response => {
          this.modals.update_modal = false;
          this.getQualifications(this.$route.query.page);
          this.getTotalQualifications();
          EventBus.$emit('updateQualificationCount');
        });
      },

      deleteQualification : function (qualification_id)
      {
        this.$store.dispatch('deleteQualification', {
          id: qualification_id
        }).then (response => {
          this.modals.confirmation_modal = false;
          this.getQualifications(this.$route.query.page);
          this.getTotalQualifications();
          EventBus.$emit('updateQualificationCount');
        });
      }
    }
  }
</script>
<style>
</style>
